module.exports = ".progress-wrapper {\n  width: 100%;\n}\n\n.progress-bar {\n  background-color: #00A3DA;\n  height: 100%;\n}"